<template>
  <Tigan :topic="topic" :index="index">
    <EssayIterm
      v-for="(item, index) in topic.childs"
      :key="index"
      :topic="item"
      :index="index"
    />
  </Tigan>
</template>
<script>
import EssayIterm from './EssayIterm.vue'
import Tigan from './Tigan.vue'
export default {
  components: {
    EssayIterm,
    Tigan
  },
  props: {
    topic: Object,
    index: Number
  }
}
</script>
<style lang="less" scoped>
.topic-box {
  padding: 12px 14px;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.topic-option {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #505873;
  .opt-index {
    margin-right: 4px;
  }
}
.topic-extra {
  display: flex;
  margin-top: 4px;
  .extra-title {
    font-weight: 700;
  }
}
.topic-img {
  margin-top: 12px;
  :deep(img) {
    width: auto !important;
    height: 92px !important;
  }
  .img-item {
    display: inline-block;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>